<template>
  <div :class="$style.container">
    <masked-input
      :id="inputId"
      v-model="internalValue"
      type="text"
      :mask="mask"
      :class="{
        [$style.field]: true,
        [$style.invalid]: isInvalid,
        [$style.spacing]: $slots.hasOwnProperty('link'),
      }"
      :placeholder="$props.placeholder"
      :disabled="disabled"
      @blur="onValidate"
      @change="$emit('change', $event)"
    />
    <label
      :for="inputId"
      :class="{
        [$style.label]: true,
        [$style.spacing]: isInvalid || disabled,
      }"
    >
      {{ label }}
    </label>

    <div :class="$style.attachmentContainer">
      <div :class="$style.attachmentPosition">

        <div :class="$style.icons">
          <div v-if="disabled" :class="$style.lockCircleIcon">
            <lock-circle-icon />
          </div>
          <div v-if="isInvalid" :class="$style.alertCircleIcon">
            <alert-circle-icon />
          </div>
        </div>

        <div v-if="$slots.hasOwnProperty('link')" :class="$style.link">
          <slot name="link" />
        </div>
      </div>

      <div v-if="$slots.hasOwnProperty('composite')" :class="$style.attachmentComposite">
        <slot name="composite" />
      </div>
    </div>
  </div>
</template>

<script>
import MaskedInput from 'vue-text-mask';
import inputMixin from './inputMixin';

import LockCircleIcon from 'atoms/icons/security/LockCircle';
import AlertCircleIcon from 'atoms/icons/notifications/AlertCircle';

export default {
  name: 'CapustaInput',
  mixins: [
    inputMixin,
  ],
  components: {
    MaskedInput,
    LockCircleIcon,
    AlertCircleIcon,
  },
  props: {
    validation: {
      type: Function,
      required: false,
    },
  },
  methods: {
    onValidate() {
      if (this.$validate.isUndefined(this.validation)) {
        return;
      }

      const isValid = this.validation();

      this.internalError = !isValid;
    },
  },
};
</script>

<style lang="sass" module>
  .container
    position: relative
    flex-grow: 1

  .label
    width: 100%
    position: absolute
    top: 0
    left: 0
    padding: 15px 20px 5px
    font-size: 14px
    line-height: 18px
    white-space: nowrap
    text-overflow: ellipsis
    overflow: hidden
    color: var(--color-input-label)

    &.spacing
      padding-right: 40px

  .field
    padding: 38px 20px 16px
    font-size: 20px
    line-height: 24px
    white-space: nowrap
    text-overflow: ellipsis
    overflow: hidden
    color: var(--color-input-text)
    background: var(--color-input-background)
    border: 1px solid var(--color-input-border)
    border-radius: 8px
    transition: all .2s linear

    &::placeholder
      color: var(--color-input-placeholder)

    &:focus
      color: var(--color-input-text-focus)
      background: var(--color-input-background-focus)
      border: 1px solid var(--color-input-border-focus)

      &::placeholder
        color: var(--color-input-placeholder-focus)

      ~ label
        color: var(--color-input-label-focus)

      ~ .link
        a
          color: var(--color-input-link-focus)

    &:disabled
      background: var(--color-input-background-disabled)
      border-color: var(--color-input-border-disabled)

      ~ label
        color: var(--color-input-label-disabled)

    &.invalid
      border-color: var(--color-input-border-invalid)
      box-shadow: var(--box-shadow-input-invalid)

      &:focus
        border-color: var(--color-input-border-focus-invalid)
        box-shadow: var(--box-shadow-input-focus-invalid)

        ~ label
          color: var(--color-input-label-focus-invalid)

      ~ label
        color: var(--color-input-label-invalid)

    &.spacing
      padding-right: 90px

  .attachmentContainer
    height: 100%
    display: flex
    position: absolute
    top: 0
    right: 0

  .attachmentPosition
    position: relative

  .icons
    display: flex
    justify-content: flex-end
    padding: 10px

    *:not(:last-child)
      margin-right: 10px

  .lockCircleIcon
    width: 22px
    height: 22px

    svg
      fill: var(--color-input-icon-disabled)

  .alertCircleIcon
    width: 22px
    height: 22px

    svg
      fill: var(--color-input-icon-invalid)

  .link
    position: absolute
    right: 20px
    bottom: 20px
    font-weight: 500
    font-size: 14px
    line-height: 17px

    a
      color: var(--color-input-link)
      text-decoration: underline

      &:hover
        text-decoration: none

  .attachmentComposite
    margin: 1px
</style>
